import Next from "../Next/next";

export const I18N_GET_TRANSLATIONS = "I18N_GET_TRANSLATIONS"
export const translationsNext = new Next('/i18n/{language}', I18N_GET_TRANSLATIONS, {headers: {'Authorization': undefined}});


